const allocationBookingTypes = {
  confirmed: { id: 'confirmed', name: 'Confirmed' },
  soft: { id: 'soft', name: 'Soft' },
};

export default allocationBookingTypes;
